export const namespaced = true

import keys from "../keys"
export const state = {
    primary_drawer:true,
    items: [
    {
        title: "New Shipment",
        url:{name:'new-shipment' },
        src:require('@/assets/drawer/new-shipment.svg'),
        src_active:require('@/assets/drawer/new-shipment-active.svg'),
        is_active_tab:false,
        access_by:[keys.WHOLESALER,keys.WAREHOUSE,keys.SUPER_ADMIN],
    },
    {
        title: "Overview",
        url:{name:'overview' },
        src:require('@/assets/drawer/overview.svg'),
        src_active:require('@/assets/drawer/overview-active.svg'),
        is_active_tab:false,
        access_by:[keys.WHOLESALER,keys.WAREHOUSE,keys.SUPER_ADMIN],
    },
    {
        title: "Shipments",
        url:{name:'shipments' },
        src:require('@/assets/drawer/shipment.svg'),
        src_active:require('@/assets/drawer/shipment-active.svg'),
        is_active_tab:false,
        access_by:[keys.WHOLESALER,keys.WAREHOUSE,keys.SUPER_ADMIN],
    },
    {
        title: "Wallet",
        url:{name:'wallet' },
        src:require('@/assets/drawer/wallet.svg'),
        src_active:require('@/assets/drawer/wallet-active.svg'),
        is_active_tab:false,
        access_by:[keys.WHOLESALER],

    },
    {
        title: "Products",
        url:{name:'products' },
        src:require('@/assets/drawer/products.svg'),
        src_active:require('@/assets/drawer/products-active.svg'),
        is_active_tab:false,
        access_by:[keys.WHOLESALER],

    },
    {
        title: "Collection",
        url:{name:'collection' },
        src:require('@/assets/drawer/wallet.svg'),
        src_active:require('@/assets/drawer/wallet-active.svg'),
        is_active_tab:false,
        access_by:[keys.WAREHOUSE,keys.SUPER_ADMIN],

    },
    {
        title: "Withdrawal",
        url:{name:'withdrawal' },
        src:require('@/assets/drawer/withdrawal.svg'),
        src_active:require('@/assets/drawer/withdrawal-active.svg'),
        is_active_tab:false,
        access_by:[keys.WAREHOUSE,keys.SUPER_ADMIN],

    },
    {
        title: "Support Tickets",
        url:{name:'support-tickets' },
        src:require('@/assets/drawer/support-ticket.svg'),
        src_active:require('@/assets/drawer/support-ticket-active.svg'),
        is_active_tab:false,
        access_by:[keys.WHOLESALER,keys.WAREHOUSE,keys.SUPER_ADMIN],

    },
    {
        title: "Profile",
        url:{name:'my-profile' },
        src:require('@/assets/drawer/username.svg'),
        src_active:require('@/assets/drawer/username-active.svg'),
        is_active_tab:false,
        access_by:[keys.WAREHOUSE],

    },
    {
        title: "Manage",
        url:{name:'manage' },
        src:require('@/assets/drawer/manage.svg'),
        src_active:require('@/assets/drawer/manage-active.svg'),
        is_active_tab:false,
        access_by:[keys.WAREHOUSE,keys.SUPER_ADMIN],

    },
    {
        title: "Subscriptions",
        url:{name:'subscription-plans' },
        src:require('@/assets/drawer/subscription.svg'),
        src_active:require('@/assets/drawer/subscription-active.svg'),
        is_active_tab:false,
        access_by:[keys.WHOLESALER],

    },
    {
        title: "Profile",
        url:{name:'wholesaler-profile' },
        src:require('@/assets/drawer/username.svg'),
        src_active:require('@/assets/drawer/username-active.svg'),
        is_active_tab:false,
        access_by:[keys.WHOLESALER],

    },


    ],
}

export const mutations = {
    SET_ACTIVE_TAB(state,index){
        localStorage.setItem("active-tab", index);

        for (let i=0; i<state.items.length; i++){
            state.items[i].is_active_tab=false;
        }

        // //setting adtive tab 

        if(index!=-1){
            let tab = state.items.filter(item => item.url.name == index);
            tab[0].is_active_tab = true;
        }
    },
    SET_PRIMARY_DRAWER(state,value){
        state.primary_drawer=value;
    },

}

export const actions = {
    setActiveTab({commit}, index){
        commit('SET_ACTIVE_TAB', index)
    },
    setPrimaryDrawer({commit}, value){
        commit('SET_PRIMARY_DRAWER', value)
    },
}
export const getters = {
    getDrawerItems:state=>{
        return state.items;
    },
    getManageTab:state=>{
        return state.items[9];
    },
}